import {
    facebook,
    instagram,
    linkedin,
    twitter,
    informatic,
    electronic,
    tool,
    Actualizacion1,
    Actualizacion2,
    foto1,
    foto2,
    foto3,
    foto4,
    foto5,
    foto8,
    foto10,
    foto11,
    foto14,
    foto15,
    foto16,
    foto17,
    foto18,
    foto20,
    foto21,
    foto24,
    foto25,
    foto26,
    foto27,
    foto28,
    foto29,
    foto30,
    foto31,
    foto32,
    acunia,
    acuniaF,
    maceira,
    muenas,
    repeto,
    vilar,
    pita,
    bazan,
    jcurellich,
    acurellich,
    ausili,
    ogas,
    nievas,
    scorciapino,
    rosenfeld,
    tesoriero,
    queralt,
    rosso,
    pignataro,
    intinni, gutierrez, salomon, estrada, depierro, garcia, casals, tejada,
    tsukazan,firpo,
} from "../assets";


export const navLinks = [
    {
        id: "home",
        title: "Inicio",
    },
    {
        id: "specifications",
        title: "Especificaciones",
    },
    {
        id: "actividades",
        title: "Nuestras Actividades",
    },

];

export const knowledge = [
    {
        id: "knowledge-1",
        icon: tool,
        title: "Mecánica",
        content:
            "Cálculos estructurales mediante sistemas de modelado CAD ......",
    },
    {
        id: "knowledge-2",
        icon: electronic,
        title: "Electrónica",
        content:
            "Integración de la electrónica, mediante el desarrollo de drivers ......",
    },
    {
        id: "knowledge-3",
        icon: informatic,
        title: "Informática",
        content:
            "Empleo del sistema operativo para robótica ROS, simulación.....",
    },
];


export const socialMedia = [
    {
        id: "social-media-1",
        icon: instagram,
        link: "https://www.fie.undef.edu.ar/",
    },
    {
        id: "social-media-2",
        icon: facebook,
        link: "https://www.fie.undef.edu.ar/",
    },
    {
        id: "social-media-3",
        icon: twitter,
        link: "https://www.fie.undef.edu.ar/",
    },
    {
        id: "social-media-4",
        icon: linkedin,
        link: "https://www.fie.undef.edu.ar/",
    },
];


export const specifications = [
    {
        id: "specification-1",
        title: "Conducción:  ",
        content: "Remota",
    },
    {
        id: "specification-2",
        title: "Peso Neto:  ",
        content: "490 kg",
    },
    {
        id: "specification-3",
        title: "Capacidad de carga: ",
        content: "260 kg",
    },
    {
        id: "specification-4",
        title: "Autonomía:  ",
        content: "150 km",
    },
    {
        id: "specification-5",
        title: "Motor:  ",
        content: "5 kW (6,5HP), 48 V",
    },
    {
        id: "specification-6",
        title: "Baterías:  ",
        content: "Li 51,2 V 100Ah - Pb-Ácido 12V 80Ah",
    },
    {
        id: "specification-7",
        title: "Malacate:  ",
        content: "12 V - 1260 kg",
    },
    {
        id: "specification-8",
        title: "Largo:",
        content: " 2,240 mm",
    },
    {
        id: "specification-9",
        title: "Ancho:  ",
        content: "1,560 mm",
    },
    {
        id: "specification-10",
        title: "Alto:  ",
        content: "1,330 mm",
    }

]

export const carrouselResources = [
    {
        "title": "ANIVERSARIO DEL EJÉRCITO ARGENTINO",
        "image": Actualizacion1,
    },
    {
        "title": "ANIVERSARIO DEL EJÉRCITO ARGENTINO",
        "image": Actualizacion2,
    },
    {
        "title": "Relevamiento de la plataforma",
        "image": foto20,
    },
    {
        "title": "Relevamiento circuito electrico",
        "image": foto5,
    },
    {
        "title": "Desarrollo de código - Phyton",
        "image": foto21,
    },
    {
        "title": "Ajuste tren delantero",
        "image": foto1,
    }, {
        "title": "Inspección de plataforma",
        "image": foto2,
    }, {
        "title": "Calibración de sensores",
        "image": foto3,
    }, {
        "title": "Montaje de luces traseras",
        "image": foto4,
    },
    {
        "title": "Primer ensamblaje",
        "image": foto8,
    },
    {
        "title": "Montaje del case electrónico",
        "image": foto10,
    },
    {
        "title": "Diseño CAD de piezas y circuito electrico",
        "image": foto11,
    },
    {
        "title": "Instalación de Baterias",
        "image": foto14,
    }, {
        "title": "Integración electrica de la iluminación",
        "image": foto15,
    },
    {
        "title": "Coordinaciones técnicas ",
        "image": foto24,
    },
    {
        "title": "Render del prototipo - 1",
        "image": foto17,
    }, {
        "title": "Render del prototipo - 2",
        "image": foto18,
    },
    {
        "title": "Render del prototipo - 3",
        "image": foto16,
    },
    {
        "title": "Pruebas ",
        "image": foto25,
    }, {
        "title": "Stand en EMGE",
        "image": foto26,
    },
    {
        "title": "Stand en EMGE",
        "image": foto28,
    },
    {
        "title": "Relevamiento informático",
        "image": foto27,
    }, {
        "title": "Prueba en terreno arenoso",
        "image": foto29,
    },
    {
        "title": "Prueba en cuidad",
        "image": foto30,
    },
    {
        "title": "Relevamiento circuito electrico",
        "image": foto31,
    },
    {
        "title": "Congreso Argentino de Ingenieria Mecanica (CAIM) 2025",
        "image": foto32,
    },
]

export const teams = {
    direccion: {
        name: "Dirección",
        members: [
            {
                "id": "member-1",
                "role": "Director del proyecto",
                "photo": acunia,
                "name": "TC OIM Marcelo Andrés Acuña",
                "link": "https://www.linkedin.com/in/marcelo-andr%C3%A9s-acu%C3%B1a-848b0410a/"
            },
            {
                "id": "member-2",
                "role": "Co-Director del proyecto",
                "photo": repeto,
                "name": "Ing. Alejandro Juan Manuel Repetto",
                "link": "https://www.linkedin.com/in/ajmrepetto/"
            },
        ]
    },
    informatica: {
        name: "Equipo Informático",
        members: [
            {
                "id": "member-3",
                "photo": maceira,
                "name": "Ingeniero - CT (R) OIM Carlos Alberto Maceira García Coni",
                "link": "https://www.linkedin.com/in/carlos-alberto-maceira-garcia-coni-b8a36137/"
            },
            {
                "id": "member-8",
                "photo": jcurellich,
                "name": "Ingeniero - CT (R) Jonathan Curellich",
                "link": "https://www.linkedin.com/in/jonathancurellich/"
            },
            {
                "id": "member-25",
                "role": "Alumno FIE",
                "photo": casals,
                "name": "CT Mauricio Casals",
                "link": "https://www.linkedin.com/in/mauricio-casals-818129115/"
            },
            {
                "id": "member-26",
                "role": "Alumno FIE",
                "photo": acuniaF,
                "name": "Francisco Manuel Acuña",
                "link": "https://www.linkedin.com/in/francisco-acu%C3%B1a-972628208/"
            },
        ]
    },
    electronica: {
        name: "Equipo Electrónico",
        members: [
            {
                "id": "member-6",
                "photo": pita,
                "name": "Ingeniero - CT Miguel Pita",
            },
            {
                "id": "member-4",
                "photo": muenas,
                "name": "Ingeniero - Guillermo Muena",
                "link": "https://www.linkedin.com/in/guillermo-a-muena-352405211/"
            },
            {
                "id": "member-7",
                "photo": bazan,
                "name": "Ingeniero - CT Daniel Bazan",
            },
            {
                "id": "member-9",
                "photo": acurellich,
                "name": "Ingeniero - CT Alex Curellich",
                "link": "http://linkedin.com/in/alex-curellich-6870612aa/"
            },
            {
                "id": "member-10",
                "photo": ausili,
                "name": "Ingeniero - TP Christian Andrés Ausili",
                "link": "https://www.linkedin.com/in/christian-andres-ausili-b74376251/"
            },
            {
                "id": "member-11",
                "photo": ogas,
                "name": "Ingeniero - 1er Alf Nahuel Ogas",
            },
            {
                "id": "member-21",
                "role": "Ex Alumno FIE",
                "photo": salomon,
                "name": "Franco Naim Salomón",
                "link": "https://www.linkedin.com/in/franco-naim-salomon-3562a5201/"
            },
            {
                "id": "member-26",
                "role": "Alumno FIE",
                "photo": tejada,
                "name": "CT Nicolás Tejada Velázquez",
                "link": "https://www.linkedin.com/in/nicolas-tejada/"
            },
            {
                "id": "member-28",
                "photo": firpo,
                "role": "Alumno FIE",
                "name": "Julian Nahuel Firpo",
                "link": "https://www.linkedin.com/in/julian-nahuel-firpo-35a706199/"
            },
        ]
    },
    mecanica: {
        name: "Equipo Mecánico",
        members: [
            {
                "id": "member-5",
                "photo": vilar,
                "name": "Ingeniero -  Pablo Vilar",
            },
            {
                "id": "member-12",
                "photo": nievas,
                "name": "Ingeniero - MY Leonardo Nievas Araya",
                "link": "https://www.linkedin.com/in/leonardo-nievas-araya-903b98323/"
            },
            {
                "id": "member-13",
                "photo": scorciapino,
                "name": "Ingeniero - MY Bernardo Scorciapino",
            },
            {
                "id": "member-15",
                "photo": tesoriero,
                "name": "Ingeniero - Sebastián Tesoriero",
                "link": "https://www.linkedin.com/in/sebastiantesoriero/"
            },
            {
                "id": "member-27",
                "photo": tsukazan,
                "name": "Ingeniero - Ignacion Tsukazan",
            },
            {
                "id": "member-14",
                "role": "Alumno FIE",
                "photo": rosenfeld,
                "name": "Darío Rosenfeld",
            },
            {
                "id": "member-17",
                "role": "Alumno FIE",
                "photo": rosso,
                "name": "Juan Rosso",
                "link": "https://www.linkedin.com/in/juan-ignacio-rosso-38b1313a9/"
            },
            {
                "id": "member-16",
                "role": "Alumno FIE",
                "photo": queralt,
                "name": "Tomás Queralt",
                "link": "https://www.linkedin.com/in/queralt-tomas/"
            },
            {
                "id": "member-18",
                "role": "Alumno FIE",
                "photo": pignataro,
                "name": "Mariano Alberto Pignataro",
                "link": "https://www.linkedin.com/in/mariano-pignataro-41a3401b7/"
            },
            {
                "id": "member-19",
                "role": "Alumno FIE",
                "photo": intinni,
                "name": "Ignacio Intinni",
            },
            {
                "id": "member-20",
                "role": "Alumno FIE",
                "photo": gutierrez,
                "name": "Leandro David Guitiérrez",
            },
            {
                "id": "member-22",
                "role": "Alumno FIE",
                "photo": estrada,
                "name": "Germán Nicolás Estrada",
                "link": "https://www.linkedin.com/in/germ%C3%A1n-nicol%C3%A1s-estrada-8617061ba/"
            },
            {
                "id": "member-23",
                "role": "Alumno FIE",
                "photo": depierro,
                "name": "Francisco Depierro",
            },
            {
                "id": "member-24",
                "role": "Alumno FIE",
                "photo": garcia,
                "name": "Joaquín García",
            },
        ]
    },
}
